export default __webpack_public_path__ + "static/media/geo-object.ccba00f5.svg";